import React, { ReactNode, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const FAQ_TAMPLATES_FOR_YEAR: { title: ReactNode; content: ReactNode }[] = [
  {
    title: "연단체 신청은 몇팀부터 가능한가요?",
    content:
      "신청접수는 보통 최소 3팀(1팀 4인)부터 가능하며, 골프장에 따라 4팀부터 예약이 가능할수도 있습니다.",
  },
  {
    title: "연간 이용회수는 몇회 이상인가요?",
    content:
      "2월~12월중 보통 년 8회 이상 이용하여야 하며, 골프장에 따라 약간 변동이 있을수 있습니다.",
  },
  {
    title: "희망 골프장은 몇 개를 할수 있나요?",
    content:
      "원하시는 골프장 3개를 신청하실 수 있으며 그중 신청조건을 수락한 골프장 중에서 선택하실 수 있습니다.",
  },
  {
    title: "연단체 매칭수수료는 얼마인가요?",
    content:
      "연단체 신청에 대한 골프장 매칭수수료는 무료이며, 매월 라운드 부킹수수료는 팀당 1만원입니다.\n\n상기 수수료는 그린피 금액 2% 수준의 최저가격이며, 골프장과의 협력비용과 서비스 운영과 개선에 사용됩니다.",
  },
  {
    title: "보증금은 무엇인가요?",
    content:
      "단체팀 노쇼(No-Show)의 발생은, 골프장에 손실을 발생하기 때문에 이를 방지하기 위하여 각 골프장에 따라 보증금 예치여부와 예치금액을 고지하고 있습니다.",
  },
  {
    title: "예약 및 취소규정은 어떻게 되나요?",
    content:
      "각 골프장 규정에 따라 조금씩 상이하기 때문에 골프장의 모집공고와 예약 및 취소규정을 확인하신 후에 선택하시기 바랍니다.",
  },
  {
    title: "위약금은 어떤 상황에서 발생하나요?",
    content:
      "1. 취소기한 이후 예약취소시 별도 위약금이 발생합니다.\n\n2. 예약팀수 위반(초과, 미달) 및 NO-SHOW 등 준수사항 위반시 익월 단체팀 예약제한 및 별도 위약금이 발생합니다.\n\n3. 위 사항은 보통 동일하게 적용되며 골프장에 따라 약간 변동이 있을수 있습니다.",
  },
];

const FAQ_TAMPLATES_FOR_EVENT: { title: ReactNode; content: ReactNode }[] = [
  {
    title: "월 단체는 무엇을 말하는 건가요?",
    content:
      "2팀 이상의 단체 부킹이며, 매월 라운드하는 연단체가 아니라 1회성으로 하는 행사, 이벤트 등을 총칭합니다.",
  },
  {
    title: "월 단체 신청은 몇팀부터 가능한가요?",
    content:
      "신청접수는 보통 최소 2팀(1팀 4인)부터 가능하며, 골프장 상황에 따라 달라질 수도 있습니다.",
  },
  {
    title: "희망 골프장은 몇 개를 할수 있나요?",
    content:
      "원하시는 골프장 3개를 신청하실 수 있으며 그중 신청조건을 수락한 골프장 중에서 선택하실 수 있습니다.",
  },
  {
    title: "월 단체 이용수수료는 얼마인가요?",
    content:
      "골프장 매칭수수료는 무료이며, 라운드 부킹수수료는 팀당 2만원입니다. \n\n 서비스 수수료는 그린피 금액 2% 수준의 최저가격이며, 골프장과의 협력비용과 서비스 운영과 개선에 사용됩니다.",
  },
  {
    title: "보증금은 무엇인가요?",
    content:
      "단체팀 노쇼(No-Show)의 발생은, 골프장에 손실을 발생하기 때문에 이를 방지하기 위하여 예치하는 금액이며, 라운드후 3영업일내에 신청인 계좌로 즉시 환불됩니다.",
  },
  {
    title: "예약 및 취소규정은 어떻게 되나요?",
    content:
      "각 골프장 규정에 따라 조금씩 상이하기 때문에 골프장의 모집공고와 예약 및 취소규정을 확인하신 후에 선택하시기 바랍니다.",
  },
  {
    title: "위약금은 어떤 상황에서 발생하나요?",
    content:
      "1. 취소기한 이후 예약취소시 별도 위약금이 발생합니다.\n\n2. 예약팀수 위반(초과, 미달) 및 NO-SHOW 등 준수사항 위반시 익월 단체팀 예약제한 및 별도 위약금이 발생합니다.\n\n3. 위 사항은 보통 동일하게 적용되며 골프장에 따라 약간 변동이 있을수 있습니다.",
  },
];

export default function FAQ(props: { faqType: "year" | "event" }) {
  const navigate = useNavigate();
  const [expandedItems, setExpandedItems] = useState<{ [key: number]: boolean }>({});
  const templateObj = { year: FAQ_TAMPLATES_FOR_YEAR, event: FAQ_TAMPLATES_FOR_EVENT };
  const faqItems = templateObj[props.faqType] || [];

  const toggleItem = (index: number) => {
    setExpandedItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <Container>
      {/* Main Content */}
      <main className="main-content">
        <h2 className="page-title">자주 묻는 질문을 확인해주세요!</h2>

        <div className="faq-list">
          {faqItems.map((item, index) => (
            <div key={index} className="faq-item">
              <div className="faq-content">
                <div className="faq-header" onClick={() => toggleItem(index)}>
                  <span className="faq-question">{item.title}</span>
                  <div className={`chevron-icon ${expandedItems[index] ? "expanded" : ""}`}>
                    <svg
                      width="12"
                      height="8"
                      viewBox="0 0 12 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.4 1.4L5.4 4.4L9.4 1.4"
                        stroke="#D1D5D8"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
                {expandedItems[index] && (
                  <div className="faq-answer">
                    <p>{item.content}</p>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </main>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  height: 844px;
  background: #f0f0f4;
  position: relative;
  font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;

  .back-button {
    width: 48px;
    height: 48px;
    position: absolute;
    left: 0;
    top: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    background: none;
    border: none;
    cursor: pointer;
  }

  .back-icon {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .main-content {
    display: flex;
    width: 100%;
    padding: 32px 25px 321px 25px;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    background: #f0f0f4;
    position: absolute;
    left: 0;
  }

  .page-title {
    color: #1a1a1a;
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    margin: 0;
    height: 22px;
  }

  .faq-list {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .faq-item {
    display: flex;
    min-height: 44px;
    padding: 10px 10px 16px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    align-self: stretch;
    border-radius: 6px;
    background: #fdfdfd;
    box-shadow: 0 0 7px -4px rgba(0, 0, 0, 0.08);
  }

  .faq-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    align-self: stretch;
  }

  .faq-header {
    display: flex;
    height: 24px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    cursor: pointer;
  }

  .faq-question {
    color: #1a1a1a;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
  }

  .chevron-icon {
    width: 24px;
    height: 24px;
    transform: rotate(0deg);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease;
  }

  .chevron-icon.expanded {
    transform: rotate(180deg);
  }

  .faq-answer {
    padding-top: 8px;
    border-top: 1px solid #f0f0f4;

    p {
      color: #79818a;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      margin: 0;
      white-space: pre-wrap;
    }
  }
`;
